<template>
    <div v-if="challanObj">
        <div class="row">
            <div class="col-6">
                <table class="table">
                    <tbody>
                        <tr>
                            <th>Chainage</th>
                            <td>
                                <input class="form-control"
                                    :value="`${this.incidentDetails.location} ${this.incidentDetails.side}`"
                                    :disabled="true" />
                            </td>
                        </tr>
                        <tr>
                            <th>Violation Time</th>
                            <td>
                                <input class="form-control"
                                    :value="`${new Date(challanObj.voilationTime).toLocaleString()}`"
                                    :disabled="true" />
                            </td>
                        </tr>
                        <tr>
                            <th>Vehicle Number</th>
                            <td>
                                <input placeholder="Please enter vehicle number" class="form-control"
                                    aria-label="Default" aria-describedby="inputGroup-sizing-default"
                                    v-model="challanObj.regnNo" />
                            </td>
                        </tr>
                        <tr>
                            <th>Vehicle Class</th>
                            <td>
                                <v-select class="style-chooser" v-model="challanObj.vehicleClassId"
                                    :options="vehicleClassMaster" label="class_name" :reduce="(vc) => vc.id"></v-select>
                            </td>
                        </tr>
                        <tr>
                            <th>Offence</th>
                            <td class="w-80">
                                <v-select class="style-chooser" v-model="challanObj.offenceId" :options="offenceMaster"
                                    label="offence" :reduce="(vc) => vc.offence_id"></v-select>
                            </td>
                        </tr>
                        <tr
                            v-if="challanObj.offenceId === 725 || challanObj.offenceId === 2392 || challanObj.offenceId === 5554">
                            <th>Vehicle Speed</th>
                            <td>
                                <input type="number" placeholder="Please enter vehicle speed" class="form-control"
                                    aria-label="Default" aria-describedby="inputGroup-sizing-default"
                                    v-model="challanObj.vehicleSpeed" :disabled="true" />
                            </td>
                        </tr>
                        <tr>
                            <th>State Code</th>
                            <td class="w-50 w-80">
                                <v-select class="style-chooser" v-model="challanObj.stateCd" :options="stateMaster"
                                    label="name" :reduce="(vc) => vc.state_code"></v-select>
                            </td>
                        </tr>
                        <tr>
                            <th>District Code</th>
                            <td>
                                <v-select class="style-chooser" v-model="challanObj.districtId"
                                    :options="districtMaster" label="name" :reduce="(vc) => vc.district_id"></v-select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="col-6">
                <table class="table">
                    <tbody>

                        <tr>
                            <th>Department</th>
                            <td>
                                <v-select class="style-chooser" v-model="challanObj.dpCd" label="name"
                                    :reduce="(vc) => vc.id" :options="departmentMaster"></v-select>
                            </td>
                        </tr>
                        <tr>
                            <th>Recording Source of Violation</th>
                            <td>
                                <v-select class="style-chooser" v-model="challanObj.violationSource" label="source_name"
                                    :reduce="(vc) => vc.source_name" :options="violationSourceMaster"></v-select>
                            </td>
                        </tr>
                        <tr>
                            <th>Location</th>
                            <td class="w-50 w-80">
                                <v-select class="style-chooser" v-model="challanObj.location" :options="locationMaster"
                                    label="location_name"></v-select>
                            </td>
                        </tr>
                        <tr v-if="challanObj.location">
                            <th>RTO Code (offCd)</th>
                            <td class="w-50 w-80">
                                <input class="form-control" v-model="challanObj.location.offcd" :disabled="true" />
                            </td>
                        </tr>
                        <tr v-if="challanObj.location">
                            <th>Equipment</th>
                            <td class="w-50 w-80">
                                <input class="form-control" v-model="challanObj.location.equipment_id"
                                    :disabled="true" />
                            </td>
                        </tr>
                        <tr v-if="challanObj.location">
                            <th>Latitude / Longitude</th>
                            <td class="w-50 w-80">
                                <input class="form-control mb-2"
                                    :value="`${challanObj.location.latitude} / ${challanObj.location.longitude}`"
                                    :disabled="true" />
                            </td>
                        </tr>
                        <tr>
                            <th>Comment</th>
                            <td class="w-50 w-80">
                                <input max="100" class="form-control" v-model="challanObj.comment" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12">
                <h4 class="card-title">Vehicle Images</h4>
                <hr />
                <img v-for="(src, index) in challanImages" :key="index" class="float-left image"
                    @click="() => showImageModal(index)" :src="src" />
            </div>
        </div>
        <hr>
        <div class="row mt-3">
            <div class="col-12">
                <div class="text-center">
                    <button type="button" @click="cancel" class="btn btn-danger me-2">
                        <i class="mdi mdi-close"></i>Cancel</button>
                    <button :disabled="requestInProgress" type="button" class="btn btn-success me-2"
                        @click="submitChallan">Send Challan to NIC
                        <i class="mdi mdi-arrow-right"></i>
                    </button>
                </div>
            </div>
        </div>
        <vue-easy-lightbox :visible="showImage" :imgs="challanImages" :index="showImageIndex"
            @hide="hideImageModal"></vue-easy-lightbox>
    </div>
</template>
<script>
import config from '@/constants/config'
import VueEasyLightbox from "vue-easy-lightbox";
import Swal from 'sweetalert2'
import incidentMixin from "../../mixins/incident";

export default {

    mixins: [incidentMixin],

    props: {
        incidentDetails: Object,
    },

    components: {
        VueEasyLightbox
    },

    data () {
        return {
            config: config,
            challanObj: {},
            showImage: false,
            showImageIndex: 1,
            departmentMaster: [{
                id: 'TR',
                name: 'TR - Transport'
            }, {
                id: 'TP',
                name: 'TP - Traffic Police'
            }],
            requestInProgress: false,
        }
    },
    computed: {
        masters () {
            return this.$store.getters["incident/masters"];
        },
        challanImages () {
            return this.incidentDetails.image_url
                ? [config.CLIENT_URL + this.incidentDetails.image_url]
                : [];
        },
        offenceMaster () {
            return this.masters.offenceIdMaster
        },
        stateMaster () {
            return this.masters.stateCodeMaster
        },
        districtMaster () {
            if (this.masters.districtCodeMaster) {
                return (this.challanObj && this.challanObj.stateCd) ? this.masters.districtCodeMaster.filter(d => d.state_code == this.challanObj.stateCd) : this.masters.districtCodeMaster
            } else return []
        },
        vehicleClassMaster () {
            return this.masters.vehicleClass
        },
        violationSourceMaster () {
            return this.masters.violationSourceMaster
        },
        locationMaster () {
            return this.masters.challanLocationMaster
        },
    },
    mounted () {

        // Set default values from config
        this.resetChallanObj()
        // this.challanObj.offenceId = this.config.NIC_DEFAULTS.offenceId

        // Set values from prop
        this.challanObj.eventId = this.incidentDetails.id
        this.challanObj.eventType = this.incidentDetails.eventType
        this.challanObj.transactionNo = this.incidentDetails.id
        this.challanObj.regnNo = this.incidentDetails.plate_no
        this.challanObj.voilationTime = this.incidentDetails.report_time ? this.incidentDetails.report_time : this.incidentDetails.reported_datetime
        this.challanObj.side = this.incidentDetails.side
        if (this.incidentDetails.eventType == 'vsds')  {
            this.challanObj.offenceId = this.incidentDetails.offenceId
            this.challanObj.vehicleSpeed = this.incidentDetails.vehicle_speed
        }

        // Select class
        const vClass = this.vehicleClassMaster.find(v => v.class_name == this.incidentDetails.type || v.id == this.incidentDetails.class_id)
        if (vClass) {
            this.challanObj.vehicleClassId = vClass.id
        }
    },
    methods: {
        async submitChallan () {

            // Set violation category name
            const violationCategory = this.offenceMaster.find(v => v.offence_id === this.challanObj.offenceId)
            this.challanObj.voilationSourceCatg = (violationCategory) ? violationCategory.offence : 'Unknown'

            // Convert image to base64
            let body = {
                ...this.challanObj,
                location: this.challanObj.location.location_name,
                equipmentId: this.challanObj.location.equipment_id,
                latitude: this.challanObj.location.latitude,
                longitude: this.challanObj.location.longitude,
                offCd: this.challanObj.location.offcd,
                vehicleSpeed: this.challanObj.vehicleSpeed != undefined && this.challanObj.vehicleSpeed != null ? this.challanObj.vehicleSpeed : 0,
                district: this.districtMaster.find(d => d.district_id === this.challanObj.districtId).name,
                images: this.challanImages,
                comment: this.challanObj.comment
            }

            // Send API Request
            try {
                this.requestInProgress = true
                await this.GenerateChallan(body);
                Swal.fire({
                    title: 'Challan Generated',
                    text: 'Challan sent to NIC',
                    icon: 'success',
                    showConfirmButton: false,
                    timer: 2000
                })

                this.$emit("close");
                this.resetChallanObj()
                this.requestInProgress = false
            } catch (e) {
                console.error(e);
                Swal.fire(
                    "Failed",
                    e.response.data.message,
                    "error"
                );
                this.requestInProgress = false
            }

        },
        cancel () {
            this.$emit('close')
        },
        showImageModal (index) {
            this.showImageIndex = index;
            this.showImage = true;
        },
        hideImageModal () {
            this.showImage = false;
        },
        resetChallanObj () {
            this.requestInProgress = false
            this.challanObj = {
                eventId: null,
                offenceId: null,
                dpCd: this.config.NIC_DEFAULTS.dpCd,
                latitude: 1.0,
                longitude: 1.0,
                transactionNo: null,
                userId: this.config.NIC_DEFAULTS.userId,
                regnNo: null,
                violationSource: null,
                voilationSourceCatg: null,
                stateCd: this.config.NIC_DEFAULTS.stateCode,
                districtId: this.config.NIC_DEFAULTS.districtId,
                location: null,
                offCd: null,
                equipmentId: null,
                vendorName: this.config.NIC_DEFAULTS.vendorName,
                vehicleSpeed: null,
                speedLimit: 80,
                vehicleWeight: 0,
                voilationTime: null,
                images: [],
                operatorId: this.$store.getters["auth/user"].user.id,
                comment: null
            }
        }
    }
}

</script>
<style scoped>
.image {
    height: 100px;
    cursor: pointer;
    margin: 5px;
    display: inline-block;
}
</style>